import React, { useEffect, useState } from 'react';
import Table from '@/components/dataDisplay/Table';
import theme from '@/constants/theme';
import { getUsers } from '@/services/authService';
import UserListOptions from './UserListOptions';

const UsersList = () => {
  const [users, setUsers] = useState<any[]>([]);

  const mapUsers = (users: any[]) => {
    return users.map((user) => ({
      id: user.id,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      role: user.role,
    }));
  };

  useEffect(() => {
    getUsers().then((response) => {
      setUsers(response);
    });
  }, []);
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        padding: 16,
        paddingTop: 32,
      }}
    >
      <h1 style={{ color: theme.colors.text.title }}>Usuarios</h1>
      <Table
        columns={[
          { title: 'Correo', field: 'email', render: (row: any) => row.email },
          { title: 'Nombre', field: 'firstName', render: (row: any) => row.firstName },
          { title: 'Apellido', field: 'lastName', render: (row: any) => row.lastName },
          { title: 'Role', field: 'role', render: (row: any) => row.role },
        ]}
        data={mapUsers(users)}
        components={{
          Action: ({ data }) => {
            const { id, email } = data;
            return (
              <UserListOptions id={id} email={email} />
            );
          },
        }}
      />
    </div>
  );
};

export default UsersList;
